import { API_TRAVEL_DESTINATIONS } from '../consts/endpoints'

export const fetchDestinations = async (transport) => {
    const response = await fetch(API_TRAVEL_DESTINATIONS, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ transport })
    })

    const dataResponse = await response.json();

    if (!response.ok) {
        throw new Error(dataResponse.message);
    }

    return dataResponse;
}
